// user 인증
export const AUTH_USER = 'AUTH_USER'
export const UNAUTH_USER = 'UNAUTH_USER'
export const STATUS_ON_LOGIN = 'STATUS_ON_LOGIN'
export const INITIAL_STATE = 'INITIAL_STATE'

export const REGISTERED_STATUS = 'REGISTERED_STATUS'
export const REGISTER_STATUS = 'REGISTER_STATUS'
export const IS_EXISTING_USER_EMAIL = 'IS_EXISTING_USER_EMAIL'


export const INITIAL_KINDER = 'INITIAL_KINDER'  //처음 시작할 때 DB의 kinder불러옴
export const MATCHED_BRANCH = 'MATCHED_BRANCH'



export const EMAIL_ERROR = 'EMAIL_ERROR'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const PASSWORD_ERROR = 'PASSWORD_ERROR'
export const AUTH_ERROR = 'AUTH_ERROR'
export const BIZ_ERROR = 'BIZ_ERROR'
export const ADDR_ERROR = 'ADDR_ERROR'
export const CODE_ERROR = 'CODE_ERROR'



// WEBPACK FOOTER //
// ./src/Auth/constants/types.js